function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.977 16.273c0 .415.335.75.75.75h6.75a.75.75 0 100-1.5h-6v-6a.75.75 0 10-1.5 0v6.75zM17.023 1.727a.75.75 0 00-.75-.75h-6.75a.75.75 0 100 1.5h6v6a.75.75 0 001.5 0v-6.75zM2.257 16.804L16.804 2.257l-1.06-1.06L1.195 15.742l1.06 1.06z",
  fill: "#EFEFEF"
});

function SvgFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _ref);
}

export default SvgFullScreen;